module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    class: {
      bold: _vm.isFolder, root: !_vm.model.id
    }
  }, [_c('a', {
    class: {
      name: true, active: _vm.isSelected(_vm.model)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectItem(_vm.model)
      }
    }
  }, [_vm._v(_vm._s(_vm.model.name))]), _vm._v(" "), (_vm.isFolder) ? _c('span', {
    on: {
      "click": _vm.toggle
    }
  }, [(_vm.open) ? _c('a', {
    staticClass: "open-link"
  }, [_vm._v(" - ")]) : _vm._e(), _vm._v(" "), (!_vm.open) ? _c('a', {
    staticClass: "open-link"
  }, [_vm._v(" + ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.isFolder) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }]
  }, _vm._l((_vm.model.children), function(model, index) {
    return _c('tree', {
      key: index,
      staticClass: "item",
      attrs: {
        "model": model,
        "selected": _vm.selected
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e00b948","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/Tree.vue
// module id = 238
// module chunks = 0